<div class="tab-container">
    <div class="table-style">
        <p class="table-name sub-form-title no-margin">Reasons</p>
        <button class="add-dates no-margin" (click)="openDialogForm()"><span class="material-icons plus-icon">
            add
            </span></button>
    </div> 
    <div *ngIf="!tableData"> No Reason Found</div> 
    <app-spinner *ngIf="showSpinner; else content"></app-spinner>     
     <ng-template #content>
    <div *ngIf="tableData?.length" class="box">
    <app-table [tableData]="tableData"  [tableColumnsNames]="columnNames"
    (rowSelected)="selectedItems($event)"></app-table>
   </div>
  </ng-template>
</div>
<ng-template #formRef>
   <div class="dialog-Container">
    <mat-dialog-actions  class="d-inline-block float-right">
     <h4 class="d-inline-block">Add New Reason</h4>
      <button mat-dialog-close class="dialog-btn-trans text-white">X</button>
    </mat-dialog-actions>
    <mat-dialog-content class="dialog-content">
        <!-- <p class="sub-form-title mandator-title dialog-sub-title">* All fields are required</p> -->
        <form class="address-form" action="" [formGroup]="reasonForm" (submit)="onReasonSubmit()">
             <mat-form-field  appearance="fill">
                <mat-label>Reason</mat-label>
                <input matInput formControlName="reason" required/>
                <mat-error *ngIf="reasonForm.get('reason').hasError('required')">
                   Please enter reason
                 </mat-error>
                 <mat-error *ngIf="!reasonForm.get('reason').hasError('required') && reasonForm.get('reason').hasError('patternValidation') ">
                    Special characters or spaces not allowed at the start and min length is 2
                  </mat-error>    
             </mat-form-field> 
             <mat-form-field  appearance="fill" *ngIf="selectedItem">
              <mat-label>Position</mat-label>
              <input matInput type="number" min=1 onkeypress="return event.charCode >= 48 && event.charCode <= 57" formControlName="index" required/>
              <mat-error *ngIf="reasonForm.get('index').hasError('required')">
                 Please enter Position 
               </mat-error>  
               <mat-error *ngIf="reasonForm.controls['index'].hasError('min')">
                You are not allowed to add decimals.
               </mat-error>  
           </mat-form-field> 
             <button mat-button *ngIf="!selectedItem" class="button-primary " [disabled]='reasonForm.invalid || btndisabled' type="submit" color="vov-ui-primary">Submit</button>
             <button mat-button *ngIf="selectedItem" class="button-primary " [disabled]='reasonForm.invalid' type="submit" (click)="editReason($event)" color="vov-ui-primary">Update</button>
        </form>
    </mat-dialog-content>
   </div>
</ng-template>
<ng-template #confirmRef>
    <div class="dialog-Container">
        <h3 mat-dialog-title>Are you sure you want to delete?</h3>
    <mat-dialog-content class="delete-Conatiner">
        <button mat-button color="vov-ui-primary"  class="confirm-btn confirm" (click)="confirmDelete()">Delete</button>
        <button mat-button (click)="onNoClick()" class="confirm-btn " tabindex="-1">Cancel</button>
      </mat-dialog-content>
    </div>
</ng-template> 